import React, { useRef, useEffect } from 'react';
import Chart from '@astrodraw/astrochart';

const ChartDrawer = ({
  planets = {},
  houses = [],
  showModernPlanets = false,
  ascendantLongitude = 0,
  birthDate = null,
  latitude = 0,
  longitude = 0
}) => {
  const chartRef = useRef();

  useEffect(() => {
    if (!chartRef.current) return;
    
    // Clear container
    chartRef.current.innerHTML = '';
    const chartId = `astrochart-${Date.now()}`;
    chartRef.current.id = chartId;

    // Convert planets to AstroChart format
    const chartPlanets = {};
    if (planets && typeof planets === 'object') {
      Object.entries(planets).forEach(([name, data]) => {
        if (!showModernPlanets && ['Uranus', 'Neptune'].includes(name)) return;
        if (data && typeof data.longitude === 'number') {
          chartPlanets[name] = [data.longitude];
        }
      });
    }

    // Get cusps from your calculation system (required by AstroChart)
    let cusps = [];
    if (houses && houses.length === 12) {
      cusps = houses.map(house => house.angle);
    } else {
      // Fallback: calculate Whole Sign houses
      const ascSign = Math.floor(ascendantLongitude / 30);
      cusps = Array.from({ length: 12 }, (_, i) => {
        const signNum = (ascSign + i) % 12;
        return signNum * 30;
      });
    }

    try {
      const chartSize = 600;
      const chart = new Chart(chartId, chartSize, chartSize);
      
      // Provide both planets and cusps as required by the library
      // The library will use birth data for ascendant calculation if available
      const data = { 
        planets: chartPlanets,
        cusps: cusps
      };
      
      chart.radix(data).aspects();
      
    } catch (error) {
      chartRef.current.innerHTML = `<div>Error rendering chart: ${error.message}</div>`;
    }
  }, [planets, houses, showModernPlanets, ascendantLongitude, birthDate, latitude, longitude]);

  return (
    <div
      ref={chartRef}
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '600px'
      }}
    />
  );
};

export default ChartDrawer;
